import type { FetchSubTypes } from '../../types'

export const fetchSubTypes: FetchSubTypes = async () =>
  Promise.resolve(['btc', 'usdt'])
